import React from 'react';

import {
  X
} from 'react-feather'

const PopupFixed = (props) => {

  return props.trigger ? (
    <div className={`background-popup`}>

      <div className="popup-box">

        <div className="popup-inner popup-inner-fixed">

          <div className="popup-header">
            <span>{props.title}</span>

            <button onClick={() => props.setTrigger(false)}>
              <X size={20} />
            </button>
          </div>

          <div className="popup-content">
            {props.children}
          </div>

        </div>

      </div>

    </div>
  ) : ("");
}

export default PopupFixed;